export function discountPercentMapper(
  current?: number | null,
  original?: number | null
): { discountPercent: string | null; discount: number | null } {
  let discount = null
  let discountPercent = null

  // this conversion is here because of amp pages pagination (data must be formatted in api response)
  if (current && original && current !== original) {
    const calculatedDiscount = original - current
    discount = calculatedDiscount

    const calculatedDiscountPrcent = ~~((calculatedDiscount * 100) / original)
    // percent can't be less than 1 todo:ss
    discountPercent = Math.max(1, calculatedDiscountPrcent).toString()
  }

  return {
    discount,
    discountPercent,
  }
}
